import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetAlumni = () => {
    const {
        isLoading, data: alumni, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: ["students/alumni"],
        queryFn: () => axiosManager.get$("/parent/api/alumni").then((response) => response?.data),
        retry: 0,
        cacheTime: 0,
        keepPreviousData: true,
        select: (data) => data?.map((item) => ({ ...item, fullName: `${item.forename} ${item.surname}` })),
    });

    return {
        isLoading,
        isRefetching,
        alumni: alumni || [],
        error,
        refetch,
    };
};
